import React, { Component } from 'react';
import moment from 'moment';
import { Example, Properties, SourceCode } from 'examples';
import Timeline from './Timeline';

const start = moment();
start.minutes(0);

const groups = [
  {
    name: 'group 1',
    items: [
      {
        start: start.clone().add(10, 'minutes'),
        end: start.clone().add(50, 'minutes')
      },
      {
        start: start.clone().add(51, 'minutes'),
        end: start.clone().add(140, 'minutes')
      },
      {
        start: start.clone().add(141, 'minutes'),
        end: start.clone().add(181, 'minutes')
      },
      {
        start: start.clone().add(181, 'minutes'),
        end: start.clone().add(225, 'minutes')
      },
      {
        start: start.clone().add(225, 'minutes'),
        end: start.clone().add(300, 'minutes')
      }
    ]
  },
  {
    name: 'group 2',
    items: [
      {
        start: start.clone().add(5, 'minutes'),
        end: start.clone().add(45, 'minutes')
      },
      {
        start: start.clone().add(46, 'minutes'),
        end: start.clone().add(120, 'minutes')
      },
      {
        start: start.clone().add(121, 'minutes'),
        end: start.clone().add(200, 'minutes')
      },
      {
        start: start.clone().add(205, 'minutes'),
        end: start.clone().add(260, 'minutes')
      },
      {
        start: start.clone().add(260, 'minutes'),
        end: start.clone().add(320, 'minutes')
      }
    ]
  },
  {
    name: 'group 3',
    items: [
      {
        id: 123,
        start: start.clone().add(25, 'minutes'),
        end: start.clone().add(92, 'minutes')
      },
      {
        start: start.clone().add(93, 'minutes'),
        end: start.clone().add(150, 'minutes')
      },
      {
        start: start.clone().add(151, 'minutes'),
        end: start.clone().add(220, 'minutes')
      },
      {
        start: start.clone().add(225, 'minutes'),
        end: start.clone().add(280, 'minutes')
      },
      {
        start: start.clone().add(280, 'minutes'),
        end: start.clone().add(340, 'minutes')
      }
    ]
  },
  {
    name: 'group 4',
    items: [
      {
        start: start.clone().add(10, 'minutes'),
        end: start.clone().add(50, 'minutes')
      },
      {
        start: start.clone().add(51, 'minutes'),
        end: start.clone().add(140, 'minutes')
      },
      {
        start: start.clone().add(141, 'minutes'),
        end: start.clone().add(181, 'minutes')
      },
      {
        start: start.clone().add(181, 'minutes'),
        end: start.clone().add(225, 'minutes')
      },
      {
        start: start.clone().add(225, 'minutes'),
        end: start.clone().add(300, 'minutes')
      }
    ]
  },
  {
    name: 'group 5',
    items: [
      {
        start: start.clone().add(10, 'minutes'),
        end: start.clone().add(50, 'minutes')
      },
      {
        start: start.clone().add(51, 'minutes'),
        end: start.clone().add(140, 'minutes')
      },
      {
        start: start.clone().add(141, 'minutes'),
        end: start.clone().add(181, 'minutes')
      },
      {
        start: start.clone().add(181, 'minutes'),
        end: start.clone().add(225, 'minutes')
      },
      {
        start: start.clone().add(225, 'minutes'),
        end: start.clone().add(300, 'minutes')
      }
    ]
  },
  {
    name: 'group 6',
    items: [
      {
        start: start.clone().add(5, 'minutes'),
        end: start.clone().add(45, 'minutes')
      },
      {
        start: start.clone().add(46, 'minutes'),
        end: start.clone().add(120, 'minutes')
      },
      {
        start: start.clone().add(121, 'minutes'),
        end: start.clone().add(200, 'minutes')
      },
      {
        start: start.clone().add(205, 'minutes'),
        end: start.clone().add(260, 'minutes')
      },
      {
        start: start.clone().add(260, 'minutes'),
        end: start.clone().add(320, 'minutes')
      }
    ]
  },
  {
    name: 'group 7',
    items: [
      {
        start: start.clone().add(25, 'minutes'),
        end: start.clone().add(92, 'minutes')
      },
      {
        start: start.clone().add(93, 'minutes'),
        end: start.clone().add(150, 'minutes')
      },
      {
        start: start.clone().add(151, 'minutes'),
        end: start.clone().add(220, 'minutes')
      },
      {
        start: start.clone().add(225, 'minutes'),
        end: start.clone().add(280, 'minutes')
      },
      {
        start: start.clone().add(280, 'minutes'),
        end: start.clone().add(340, 'minutes')
      }
    ]
  },
  {
    name: 'group 8',
    items: [
      {
        start: start.clone().add(10, 'minutes'),
        end: start.clone().add(50, 'minutes')
      },
      {
        start: start.clone().add(51, 'minutes'),
        end: start.clone().add(140, 'minutes')
      },
      {
        start: start.clone().add(141, 'minutes'),
        end: start.clone().add(181, 'minutes')
      },
      {
        start: start.clone().add(181, 'minutes'),
        end: start.clone().add(225, 'minutes')
      },
      {
        start: start.clone().add(225, 'minutes'),
        end: start.clone().add(300, 'minutes')
      }
    ]
  }
];

export default class TimelineExample extends Component {
  static defaultProps = {
    groups
  };

  constructor(props) {
    super();
    this.state = {
      startTime: start,
      currentDate: start,
      page: null,
      groups
    };
  }

  onChangeDate = (date) => {
    this.setState({
      currentDate: date ? date.clone() : null
    });
  };

  onChangePage = (startDate, endDate) => {
    this.setState({ page: { startDate, endDate } });
  };

  onPropChange = (e) => {
    this.setState(e.target.value);
  };

  render() {
    return (
      <Example {...this.props}>
        <Properties
          defaultProps={Timeline.defaultProps}
          onChange={this.onPropChange}
          propTypes={Timeline.propTypes}
          propValues={this.state}
        />
        <div style={{ marginBottom: 20 }}>
          {this.state.currentDate.format('LL')}
        </div>
        <div style={{ marginBottom: 20 }}>
          Data interval:{' '}
          {this.state.page
            ? `${this.state.page.startDate.format()} - ${this.state.page.endDate.format()}`
            : ''}
        </div>
        <div style={{ display: 'flex', overflow: 'hidden', maxHeight: 400 }}>
          <Timeline
            {...this.state}
            onChangeDate={this.onChangeDate}
            onChangePage={this.onChangePage}
          />
        </div>
        <SourceCode
          language="javascript"
          title="Using external state to control the start time">
          {'/* This approach is useful if you want to have addiional controls for the timeline */\n' +
            '\n' +
            'constructor() {\n' +
            '  this.state = { startTime: moment() }\n' +
            '}\n' +
            '\n' +
            'setStartTime(startTime) {\n' +
            '  this.setState({ startTime })\n' +
            '}\n' +
            '\n' +
            'render() {\n' +
            '  return (<Timeline startTime={this.state.startTime} setStartTime={this.setStartTime.bind(this)}/>);\n' +
            '}'}
        </SourceCode>
        <SourceCode language="javascript" title="The onChangeDate callback">
          {'/* When the timeline scrolls into a new day if will fire an event with the current display date */\n' +
            '\n' +
            'constructor() {\n' +
            '  this.state = { selected: moment() }\n' +
            '}\n' +
            '\n' +
            'onChangeDate(moment) {\n' +
            '  // the date parameter is a moment object\n' +
            '  this.setState({ selected: moment })\n' +
            '}\n' +
            '\n' +
            'render() {\n' +
            '  return (<Timeline onChangeDate={this.onChangeDate.bind(this)} startTime={this.state.selected}/>);\n' +
            '}'}
        </SourceCode>

        <SourceCode language="javascript" title="The onChangePage callback">
          {'/* When the timeline is about to scroll into a timeframe it does not have data for it will fire an event to trigger actions for fetching data */\n' +
            '\n' +
            'onChangePage(startDate, endDate) {\n' +
            '  // the date parameter is a moment object\n' +
            '  actions.fetchData(startDate, endDate)\n' +
            '}\n' +
            '\n' +
            'render() {\n' +
            '  return (<Timeline onChangePage={this.onChangePage.bind(this)} startTime={this.state.selected}/>);\n' +
            '}'}
        </SourceCode>
      </Example>
    );
  }
}
